// Mock data for Meya Beauté & Tradition

export const services = {
  revitalisation: [
    {
      id: 'rev1',
      name: 'Massage Nigella',
      duration: '40 min',
      description: "Massage à l'huile de nigelle chaude, reconnue pour ses vertus réparatrices, revitalisantes et apaisantes.",
      price: 40,
      firstVisitPrice: 36
    },
    {
      id: 'rev2',
      name: "Massage Sésame d'Orient",
      duration: '40 min',
      description: "Massage à l'huile de sésame chaude, idéale pour détendre les muscles et stimuler la circulation.",
      price: 40,
      firstVisitPrice: 36
    },
    {
      id: 'rev3',
      name: 'Massage Sahara',
      duration: '40 min',
      description: "Massage à l'huile de dattier ou de figue de barbarie, nourrissante et régénérante pour hydrater, raffermir et revitaliser la peau.",
      price: 40,
      firstVisitPrice: 36
    }
  ],
  
  piedsMains: [
    {
      id: 'pm1',
      name: 'Beauté des pieds',
      subtitle: 'PÉDICURE ET SOINS NATUREL',
      description: 'Soin complet pour des pieds doux, sains et naturellement sublimés.',
      price: 30,
      icon: 'feet'
    },
    {
      id: 'pm2',
      name: 'Beauté des mains',
      subtitle: 'MANUCURE JAPONAISE',
      description: 'Soin traditionnel pour renforcer, nourrir et sublimer vos ongles naturellement.',
      price: 30,
      icon: 'hands'
    }
  ],
  
  mereFille: {
    name: 'Moment détente Mère et Fille',
    price: 60,
    deposit: 30,
    schedule: {
      mercredi: ['13h - 14h30', '16h - 17h30'],
      samedi: ['11h - 12h30', '14h - 15h30'],
      dimanche: ['11h - 12h30', '14h - 15h30']
    },
    includes: [
      "Un véritable Soin du visage adapté en fonction de l'âge avec activité durant le temps maman",
      'Massage',
      'Henné simple 1 mains',
      'Séance photo',
      'Une pâtisserie, des brochettes de fruits et deux boisson inclus'
    ],
    note: 'Peignoir et chaussons inclus'
  },
  
  femmeEnceinte: [
    {
      id: 'fe1',
      name: 'Massage Prénatal',
      duration: '1h',
      description: 'Massage adapté aux femmes enceintes, pour soulager les tensions et apporter un moment de détente profonde.',
      price: 60,
      firstVisitPrice: 54
    },
    {
      id: 'fe2',
      name: 'Massage Postnatal',
      duration: '1h',
      description: "Massage adapté après l'accouchement, pour accompagner la récupération du corps, avec la présence du bébé possible ou non.",
      price: 60,
      firstVisitPrice: 54
    },
    {
      id: 'fe3',
      name: 'Massage Postnatal + serrage de bassin',
      duration: '45 min',
      description: "Soin dédié aux femmes après l'accouchement incluant massage et serrage de bassin traditionnel pour aider le corps à se recentrer.",
      price: 45,
      firstVisitPrice: 40
    }
  ],
  
  detente: [
    {
      id: 'det1',
      name: 'Massage Signature MEYA',
      duration: '45 min',
      description: "Massage à l'huile chaude du désert, inspiré des rituels traditionnels, idéal pour relâcher les tensions et procurer un profond bien-être.",
      price: 45,
      firstVisitPrice: 40
    },
    {
      id: 'det2',
      name: 'Massage Amna (massage doux)',
      duration: '45 min',
      description: 'Massage doux aux huiles naturelles (amande douce, jojoba ou avocat), parfait pour une relaxation profonde et une peau nourrie.',
      price: 45,
      firstVisitPrice: 40
    },
    {
      id: 'det3',
      name: 'Massage + drainage visage',
      duration: '35 min',
      description: "Massage associé à un drainage du visage à l'huile de raisin, pour détendre les traits et stimuler la circulation.",
      price: 35,
      firstVisitPrice: 31
    }
  ],
  
  beauteRegard: [
    {
      id: 'br1',
      name: 'Rehaussement de cils',
      price: 25
    },
    {
      id: 'br2',
      name: 'Restructuration des sourcils',
      subtitle: 'AVEC DÉCOLORATION + Teinture',
      price: 35
    },
    {
      id: 'br3',
      name: 'Restructuration des sourcils',
      subtitle: 'AVEC DÉCOLORATION sans teinture',
      price: 25
    },
    {
      id: 'br4',
      name: 'Le Pack Complet',
      subtitle: 'REHAUSSEMENT DE CILS + RESTRUCTURATION DES SOURCILS',
      description: '(DÉCOLORATION + TEINTURE)',
      price: 45
    },
    {
      id: 'br5',
      name: 'Browlift avec Teinture',
      price: 25
    },
    {
      id: 'br6',
      name: 'Browlift sans Teinture',
      price: 20
    }
  ],
  
  anniversaire: {
    mini: {
      name: 'Mini Spa expérience',
      price: 25,
      perPerson: true,
      minPersons: 8,
      maxPersons: 10,
      duration: '2h30',
      ageRange: '4 à 16 ans',
      reservation: 30,
      formula: 'Une formule au choix',
      boxes: ['BOX SKINCARE', 'BOX RELAX', 'BOX NAIL ARTIST', 'BOX GLOSSY'],
      boxDetails: {
        skincare: [
          'Mocktail de Bienvenue',
          'Atelier Crée ton Masque Visage',
          'On prend soin de sa peau',
          'Remise en Beauté & Coiffure de Princesse'
        ],
        relax: [
          'Mocktail de Bienvenue',
          'Atelier Crée ton Gommage',
          'On prend soin de ses pieds',
          'Remise en Beauté & Coiffure de Princesse'
        ],
        nailArtist: [
          'Mocktail de Bienvenue',
          'Atelier Crée ton Huile à Cuticules',
          'Pose de Vernis & Décorations',
          'Remise en Beauté & Coiffure de Princesse'
        ],
        glossy: [
          'Mocktail de Bienvenue',
          'Atelier Crée ton Gloss',
          'Maquillage & Tatouage Henné',
          'Remise en Beauté & Coiffure de Princesse'
        ]
      },
      includes: [
        'Shooting photo professionnel',
        'Sachet de bonbons et boissons',
        'Box spa offert pour tous les invités',
        'Cartons d\'invitation fournis en physique',
        'Peignoir et chaussons inclus'
      ]
    },
    deluxe: {
      name: 'Deluxe Spa Day',
      price: 50,
      perPerson: true,
      minPersons: 6,
      maxPersons: 10,
      duration: '3h',
      ageRange: '4 à 16 ans',
      reservation: 30,
      formula: 'Une formule au choix + 2 Soins au choix ou 1 Atelier au choix supplémentaires',
      boxes: ['BOX SKINCARE', 'BOX RELAX', 'BOX NAIL ARTIST', 'BOX GLOSSY'],
      boxDetails: {
        skincare: [
          'Mocktail de Bienvenue',
          'Atelier Crée ton Masque Visage',
          'On prend soin de sa peau',
          'Remise en Beauté & Coiffure de Princesse'
        ],
        relax: [
          'Mocktail de Bienvenue',
          'Atelier Crée ton Gommage',
          'On prend soin de ses pieds',
          'Remise en Beauté & Coiffure de Princesse'
        ],
        nailArtist: [
          'Mocktail de Bienvenue',
          'Atelier Crée ton Huile à Cuticules',
          'Pose de Vernis & Décorations',
          'Remise en Beauté & Coiffure de Princesse'
        ],
        glossy: [
          'Mocktail de Bienvenue',
          'Atelier Crée ton Gloss',
          'Maquillage & Tatouage Henné',
          'Remise en Beauté & Coiffure de Princesse'
        ]
      },
      includes: [
        'Shooting photo professionnel',
        'Sachet de bonbons et boissons',
        'Box spa offert pour tous les invités',
        'Cartons d\'invitation fournis en physique',
        'Les ateliers sont personnalisé en fonction de la tranche d\'âge',
        'Peignoir et chaussons inclus'
      ]
    },
    luxury: {
      name: 'Luxury Spa Day',
      price: 90,
      perPerson: true,
      minPersons: 3,
      maxPersons: 10,
      duration: '4h',
      ageRange: '4 à 16 ans',
      reservation: 30,
      formula: 'Une formule au choix + 4 Soins et 2 ateliers aux choix supplémentaires',
      boxes: ['BOX SKINCARE', 'BOX RELAX', 'BOX NAIL ARTIST', 'BOX GLOSSY'],
      boxDetails: {
        skincare: [
          'Mocktail de Bienvenue',
          'Atelier Crée ton Masque Visage',
          'On prend soin de sa peau',
          'Remise en Beauté & Coiffure de Princesse'
        ],
        relax: [
          'Mocktail de Bienvenue',
          'Atelier Crée ton Gommage',
          'On prend soin de ses pieds',
          'Remise en Beauté & Coiffure de Princesse'
        ],
        nailArtist: [
          'Mocktail de Bienvenue',
          'Atelier Crée ton Huile à Cuticules',
          'Pose de Vernis & Décorations',
          'Remise en Beauté & Coiffure de Princesse'
        ],
        glossy: [
          'Mocktail de Bienvenue',
          'Atelier Crée ton Gloss',
          'Maquillage & Tatouage Henné',
          'Remise en Beauté & Coiffure de Princesse'
        ]
      },
      includes: [
        'Shooting photo professionnel',
        'Sachet de bonbons et boissons',
        'Box spa offert pour tous les invités',
        'Cartons d\'invitation fournis en physique',
        'Les ateliers sont personnalisé en fonction de la tranche d\'âge',
        'Peignoir et chaussons inclus'
      ]
    }
  }
};

// Mock availability data for booking calendar
export const mockAvailability = {
  '2025-01-15': ['09:00', '11:00', '14:00', '16:00'],
  '2025-01-16': ['10:00', '14:00', '15:30'],
  '2025-01-17': ['09:00', '13:00', '16:00'],
  '2025-01-18': ['11:00', '14:00'],
  '2025-01-20': ['09:00', '10:30', '14:00', '16:00'],
  '2025-01-21': ['10:00', '13:00', '15:00'],
  '2025-01-22': ['09:00', '11:00', '14:00', '16:30'],
  '2025-01-23': ['10:00', '14:00', '16:00'],
  '2025-01-24': ['09:00', '13:00', '15:00'],
  '2025-01-25': ['11:00', '14:00', '16:00']
};

// Contact information
export const contactInfo = {
  address: '6 rue du vivarais',
  postalCode: '54500',
  city: 'Vandoeuvre-lès-Nancy',
  phone: '07.69.21.27.09',
  phoneRaw: '0769212709',
  email: 'meyanancyy@gmail.com',
  hours: 'Sur rendez-vous',
  socialMedia: {
    instagram: '#',
    facebook: '#'
  }
};
